import styled from 'styled-components';

export const ProjectSelectList = styled.ul`
    list-style-type: none;
    margin: 0;
    padding: 0;
    color: black;
`;
export const ProjectSelectListItem = styled.li.attrs(props => ({
    paddingVertical: props.paddingVertical || 6,
    fontSize: props.fontSize || '100%',
}))`
    border: 1px solid #DDDDDD;
    border-radius: 3px;
    margin: 4px;
    padding: ${props => `${props.paddingVertical}px`} 4px;
    background-color: white;
    transition: all 0.2s ease-in-out ;
    cursor: pointer;
    font-size: ${props => props.fontSize};
    ${props => props.selected && `
        font-weight: bold;
    `}
    &:hover {
        transition: all 0.2s ease-in-out;
        border-color: #BBBBBB;
        background-color: #EEEEEE;
        box-shadow: 2px 2px 3px -1px rgba(0,0,0,0.5);
    }
`;